import { AssignDivisionsForm } from 'components/forms/assign-divisions-form/assign-divisions-form';
import { useCallback } from 'react';
import { closeModal } from 'store/modals/modals.slice';

import { ASSIGN_DIVISION_MODAL } from '../../../shared/constants/modals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { Modal } from '../../template/modals/modal';

export const AssignDivisionsModal = () => {
  const dispatch = useAppDispatch();

  const modal = useAppSelector((state) =>
    state.modals.find((modal) => modal.name === ASSIGN_DIVISION_MODAL),
  );

  const handleClose = useCallback(() => {
    dispatch(closeModal({ name: ASSIGN_DIVISION_MODAL }));
  }, [dispatch]);

  if (!modal || !modal.isOpen) {
    return null;
  }

  return (
    <Modal close={handleClose}>
      <AssignDivisionsForm />
    </Modal>
  );
};
